import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  ClassifyKeywordColorsRequest,
  ClassifyKeywordColorsResponse,
  HttpResponse,
} from "@/types";

export const useClassifyKeywordColors = () => {
  return useMutation({
    mutationFn: async (
      request: ClassifyKeywordColorsRequest,
    ): Promise<ClassifyKeywordColorsResponse> => {
      const res = await guacHttpClient.post<
        ClassifyKeywordColorsResponse,
        HttpResponse<ClassifyKeywordColorsResponse>,
        ClassifyKeywordColorsRequest
      >("search/classify-keyword-colors", request);
      return res.data;
    },
  });
};
